"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = exports.Bang = exports.Round = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../styles/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Round = _styledComponents["default"].div.withConfig({
  displayName: "style__Round",
  componentId: "sc-1735xos-0"
})(["width:7px;height:7px;background-color:", ";text-align:center;margin:9px;border-radius:50%;"], _colors["default"].red);

exports.Round = Round;

var Bang = _styledComponents["default"].div.withConfig({
  displayName: "style__Bang",
  componentId: "sc-1735xos-1"
})(["width:1px;height:7px;position:relative;margin:-12px 0px 0px 12px;background-color:", ";"], _colors["default"].red);

exports.Bang = Bang;

var Tooltip = _styledComponents["default"].div.withConfig({
  displayName: "style__Tooltip",
  componentId: "sc-1735xos-2"
})(["position:absolute;top:-15px;width:100px;height:100px;background-color:", ";z-index:5;border-radius:5px;opacity:0;&:hover{opacity:1;}"], _colors["default"].white.primary);

exports.Tooltip = Tooltip;